import React, { useState } from 'react'
import { useUser } from '../context/user'
import { update } from '../server/server'
import { notify } from '../utils/util'
import '../styles/PrivacyAndSecurity.css'
import { useTranslation } from 'react-i18next'
import { useToasts } from 'react-toast-notifications'

export default function PrivacyAndSecurity(props) {
    const { user, setUser } = useUser()
    const [password, setPassword] = useState('')
    const [email, setEmail] = useState(user.email)
    const [retypedPassword, setRetypedPassword] = useState('')
    const { t } = useTranslation()
    const { addToast } = useToasts()

    const [passwordError, setPasswordError] = useState('')
    const [retypedPasswordError, setRetypedPasswordError] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [showRetypedPassword, setShowRetypedPassword] = useState(false)

    const validatePassword = (pass) => {
        const minLength = pass.length >= 8
        const upper = /[A-Z]/.test(pass)
        const lower = /[a-z]/.test(pass)
        const number = /[0-9]/.test(pass)
        const special = /[^A-Za-z0-9]/.test(pass)

        return minLength && upper && lower && number && special
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        let hasError = false

        setPasswordError('')
        setRetypedPasswordError('')

        if (!password) {
            setPasswordError(t('required'))
            hasError = true
        } else if (!validatePassword(password)) {
            setPasswordError(t('passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol'))
            hasError = true
        }

        if (!retypedPassword) {
            setRetypedPasswordError(t('required'))
            hasError = true
        } else if (password !== retypedPassword) {
            setRetypedPasswordError(t('passwordsDoNotMatch'))
            hasError = true
        }

        if (hasError) return

        let _user = { ...user, email }
        _user['password'] = password
        _user['new_password'] = true

        const resp = await update({ collection: 'users', data: _user })

        if (resp.status === 200) {
            addToast(t('userIsUpdated'), {
                appearance: 'success',
                autoDismiss: true,
            })

            setUser(_user)

            setPassword('')
            setRetypedPassword('')
        }
    }

    const EyeIcon = ({ open }) => {
        return open ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
        ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-6 0-10-7-10-7a21.77 21.77 0 0 1 5.06-6.94" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c6 0 10 7 10 7a21.77 21.77 0 0 1-4.16 5.19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="2" y1="2" x2="22" y2="22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        )
    }

    return (
        <div className="personal-info-container shadow-custom-soft ">
            <div className="notes-title">{t('changePassword')}</div>

            <div className="privacy-form">
                <form onSubmit={handleSubmit}>
                    <div className="advance-settings-label" style={{ marginBottom: 10 }}>
                        {t('Create a new password')}
                    </div>
                    <div className="advance-settings-label" style={{ marginBottom: 10 }}>
                        {t('Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.')}
                    </div>
                    <div>
                        <div htmlFor="password">
                            <p className="privacy-settings-attention">{t('newPassword')}</p>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={t('Enter your new password')}
                            />

                            <span
                                onClick={() => setShowPassword((prev) => !prev)}
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: '#153c4f',
                                    transition: 'color 0.2s',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = '#3c8794')}
                                onMouseLeave={(e) => (e.currentTarget.style.color = '#153c4f')}
                            >
                                <EyeIcon open={showPassword} />
                            </span>
                        </div>
                        {passwordError && <span className="input-error-text">{passwordError}</span>}
                    </div>
                    <div>
                        <div htmlFor="retyped_password">
                            <p className="privacy-settings-attention">{t('Confirm new password')}</p>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showRetypedPassword ? 'text' : 'password'}
                                value={retypedPassword}
                                onChange={(e) => setRetypedPassword(e.target.value)}
                                placeholder={t('Re-enter your new password')}
                            />

                            <span
                                onClick={() => setShowRetypedPassword((prev) => !prev)}
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: '#153c4f',
                                    transition: 'color 0.2s',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = '#3c8794')}
                                onMouseLeave={(e) => (e.currentTarget.style.color = '#153c4f')}
                            >
                                <EyeIcon open={showRetypedPassword} />
                            </span>
                        </div>
                        {retypedPasswordError && <span className="input-error-text">{retypedPasswordError}</span>}
                    </div>

                    <button className="generic-submit-button" style={{ marginTop: 40 }}>
                        {t('save')}
                    </button>
                </form>
            </div>
        </div>
    )
}
